<template><div><h1 id="zahlungen-an-projekte" tabindex="-1"><a class="header-anchor" href="#zahlungen-an-projekte"><span>Zahlungen an Projekte</span></a></h1>
<p>Zahlungen an Projekte — Listet Zahlungen an Projekte aus</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Liste, welche für die gewählte(n) Projektgruppe(n) und einen definierten Zeitraum alle Projekte auflistet, mit zugehörigen Ereignissen und Responsewerten pro Adresse, unterschieden nach Individual- und Kollektivmarketing.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Zahlungen an Projekte</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Projektgruppen</dt>
<dd>mit Kommas trennen, mit ! ausschliessen, * alle</dd>
<dt>Datum von</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Datum bis</dt>
<dd>leer = unbegrenzt, Inklusive</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Landscape)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ProjGr.</td>
<td>Projektgruppe</td>
</tr>
<tr>
<td>Projekt</td>
<td>Projektnummer</td>
</tr>
<tr>
<td>Ereig.</td>
<td>Ereignis</td>
</tr>
<tr>
<td>Adrnum</td>
<td>Personen-ID</td>
</tr>
<tr>
<td>Name</td>
<td>Name</td>
</tr>
<tr>
<td>Ort</td>
<td>Ort</td>
</tr>
<tr>
<td>Datum</td>
<td>Zahlungsdatum</td>
</tr>
<tr>
<td>individuell</td>
<td>Umsatzwert, wenn Adresse im Individualmarketing ist</td>
</tr>
<tr>
<td>kollektiv</td>
<td>Umsatzwert, wenn Adresse im Kollektivmarketing ist</td>
</tr>
<tr>
<td>Total</td>
<td>1. Total pro Ereignis</td>
</tr>
<tr>
<td>Total</td>
<td>2. Total pro Projekt</td>
</tr>
<tr>
<td>Total</td>
<td>3. Total pro Projektgruppe</td>
</tr>
<tr>
<td>Total</td>
<td>4. Total = Gesamtsumme</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                          19.02.2004 11:16:21 svw  Seite     0</span>
<span class="line"></span>
<span class="line">                            Zahlungen an Projekte</span>
<span class="line">                Projektgruppen: 200BE</span>
<span class="line">                Datum von.....: 01.01.2003 bis: 31.01.2003</span>
<span class="line"></span>
<span class="line"></span>
<span class="line">ProjGr.  Projekt Ereig.   Adrnum Name           Ort          Datum      individuell   kollektiv</span>
<span class="line">-------- ------- ------ -------- -------------- ------------ ---------- ----------- -----------</span>
<span class="line">200BE    822130    9578   121117 Haffner Elisab Meilen       27.01.2003     1200.00        0.00</span>
<span class="line">.        .         .     1793361 Hug Johann-Rud Zug          16.01.2003      500.00        0.00</span>
<span class="line">                                                                        ----------- -----------</span>
<span class="line">                                                                            1700.00        0.00 TOTAL</span>
<span class="line">                                                                        ----------- -----------</span>
<span class="line">                                                                            1700.00        0.00 TOTAL</span>
<span class="line">                                                                        ----------- -----------</span>
<span class="line">                                                                            1700.00        0.00 TOTAL</span>
<span class="line"></span>
<span class="line">                                                                        ----------- -----------</span>
<span class="line">                                                                            1700.00        0.00 TOTAL</span>
<span class="line"></span>
<span class="line">Die Adresse 121117 hat am 27.01.2003 Franken 1200.-- einbezahlt. Die Zahlung wurde auf Projekt 822130 (über Ereignis 9578) verbucht und wird nun unter der Projektgruppe 200BE ausgewiesen.</span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></div></template>


